var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M170.667 0L140.48 30.187l119.147 119.146H0V192h259.627L140.48 311.147l30.187 30.186 170.666-170.666z"}));
}

RightArrowInline.defaultProps = {"viewBox":"0 0 341.333 341.333"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
